<app-home-header *nstarContent="'header'"></app-home-header>
<div class="container-lg my-3">
	<app-toolbar *nstarContent="'toolbar'" [containerClass]="'container-lg'">
		<div class="row gx-lg-0">
			<div class="col-6 order-0 col-sm-auto col-lg-auto">
				<app-listing-type-select
					[control]="listingSummaryRequestForm.get('propertyTypeCD')"
				></app-listing-type-select>
			</div>
			<div class="col-6 order-0 d-flex justify-content-end col-sm-auto d-sm-block col-lg-auto">
				<app-listing-status-select
					[control]="listingSummaryRequestForm.get('listingStatusCD')"
				></app-listing-status-select>
			</div>
			<div class="col-9 order-1 col-sm-auto flex-grow-1">
				<app-listing-timeframe-select
					[control]="listingSummaryRequestForm.get('when')"
				></app-listing-timeframe-select>
			</div>
			<div class="col-9 d-flex justify-content-start order-2 col-sm col-md-10 col-lg-auto">
				<app-dropdown-select
					[tooltip]="'Page Size'"
					[control]="pageSizeControl"
					[options]="pageSize$ | async"
					[label]="'Page Size'"
					dropdownMenuClass="checkbox-dropdown"
				></app-dropdown-select>
				<app-listing-sort-select
					[control]="listingSummaryRequestForm.get('sortColumn')"
				></app-listing-sort-select>
			</div>
			<div class="col order-1 d-flex justify-content-end order-lg-4 col-lg-auto">
				<ng-container *ngIf="cardOrRow$ | async as cardOrRowCurrent">
					<button
						*ngIf="cardOrRowCurrent !== 'row'"
						(click)="cardOrRow = 'row'"
						ngbTooltip="List View"
						nstarButton
						class="btn d-inline grid-btn"
					>
						<i nstarIcon>grid</i>
					</button>
					<button
						*ngIf="cardOrRowCurrent === 'row'"
						(click)="cardOrRow = 'card'"
						ngbTooltip="Card View"
						nstarButton
						class="btn d-inline card-btn"
					>
						<i nstarIcon>cards</i>
					</button>
				</ng-container>
			</div>
			<div class="col order-3 d-flex justify-content-end order-lg-4 col-lg-auto">
				<button
					ngbTooltip="Help"
					[nstarHelp]="{ module: 'HomePage', page: null }"
					nstarButton
					class="btn d-inline help-btn"
				>
					<i nstarIcon>help</i>
				</button>
			</div>
		</div>
	</app-toolbar>
	<app-add-button
		*ngIf="canAdd$ | async"
		[routerLink]="['/', 'listing', 'new']"
		tabindex="-1"
	></app-add-button>
	<ng-template #welcomeTemplate>
		<div class="row justify-content-center my-5" *ngIf="showWelcome$ | async">
			<div class="col-12 col-md-9 col-lg-8 text-center">
				<h2 class="text-primary display-4">Welcome to Add/Edit</h2>
				<p class="text-dark">
					Select filters above to browse properties<span *ngIf="canAdd$ | async"
						>,<br />
						or use the (+) button (lower right) to create a new listing</span
					>.
				</p>
			</div>
		</div>
	</ng-template>
	<div
		class="container-lg"
		*ngIf="listingSummaryRequestFormInvalid$ | async; else listingsTemplate"
	>
		<div *ngIf="!(showWelcome$ | async)" class="col-12 text-center">
			You must select at least one listing type and one listing status. Please try again.
		</div>
		<ng-container *ngTemplateOutlet="welcomeTemplate"></ng-container>
	</div>
	<ng-template #listingsTemplate>
		<ng-container *ngIf="!(loading$ | async); else loadingTemplate">
			<div class="container-lg" *ngIf="listing$ | async as listings; else loadingTemplate">
				<ng-container *ngTemplateOutlet="welcomeTemplate"></ng-container>
				<ng-container *ngTemplateOutlet="paginationTemplate"></ng-container>
				<table
					*ngIf="(cardOrRow$ | async) === 'row' && (!(showWelcome$ | async) || listings.length > 0)"
					class="table table-striped my-3"
				>
					<thead
						class="text-light"
						[ngClass]="{ ascending: isSortAscControl.value, descending: !isSortAscControl.value }"
					>
						<tr [class]="sortColumnControl.value">
							<th class="bg-secondary rounded-start border-0"></th>
							<th
								(click)="setSortColumn(listingSortColumn.MLID)"
								class="bg-secondary border-0 MLID"
							>
								MLS #
							</th>
							<th
								(click)="setSortColumn(listingSortColumn.MEMBER_NAME)"
								class="bg-secondary border-0 ListAgent1Name"
							>
								Agent
							</th>
							<th
								(click)="setSortColumn(listingSortColumn.STATUS_NAME)"
								class="bg-secondary border-0 Status"
							>
								Status
							</th>
							<th
								(click)="setSortColumn(listingSortColumn.CITY_NAME)"
								class="bg-secondary border-0 City"
							>
								Address
							</th>
							<th
								(click)="setSortColumn(listingSortColumn.PRICE)"
								class="bg-secondary border-0 ListPrice"
							>
								Price
							</th>
							<th
								(click)="setSortColumn(listingSortColumn.DATE)"
								class="bg-secondary border-0 ListDate"
							>
								List Date
							</th>
							<th
								(click)="setSortColumn(listingSortColumn.EXPIRATION)"
								class="bg-secondary border-0 ExpirationDate"
							>
								Exp. Date
							</th>
							<th class="bg-secondary rounded-end border-0"></th>
						</tr>
					</thead>
					<app-listing-row
						(click)="navigateToListing(listing)"
						class="hover-target hover-bg-translucent-blue hover-text-light border-0"
						style="display: table-row"
						*ngFor="
							let listing of listings
								| paginate : (currentPage$ | async) || 1 : +pageSizeControl?.value || 10
						"
						[listing]="listing"
						[showPreviewAd]="listing?.showPreviewAd || false"
						(deleted)="openModal($event, deleteModal)"
						(recovered)="openModal($event, recoverModal)"
						(copied)="openModal($event, copyModal)"
						(cloned)="openModal($event, cloneModal)"
						(previewAdEvent)="navigateToAd($event)"
					></app-listing-row>
					<tr
						*ngIf="(!listings || listings.length === 0) && !(showWelcome$ | async)"
						class="border-0"
					>
						<td colspan="9" class="text-center">
							No listings found with the given criteria. Please try again.
						</td>
					</tr>
				</table>
				<div *ngIf="(cardOrRow$ | async) !== 'row'" class="row g-3 g-xl-4 mt-2 mb-4">
					<app-listing-card
						(click)="navigateToListing(listing)"
						(navigate)="navigateToListing(listing)"
						*ngFor="
							let listing of listings
								| paginate : (currentPage$ | async) || 1 : +pageSizeControl?.value || 10
						"
						[showPreviewAd]="listing?.showPreviewAd || false"
						[hasPreviewPermissions]="showPreviewAd$ | async"
						class="col-12 col-sm-6"
						[listing]="listing"
						(deleted)="openModal($event, deleteModal)"
						(recovered)="openModal($event, recoverModal)"
						(copied)="openModal($event, copyModal)"
						(cloned)="openModal($event, cloneModal)"
						(previewAdEvent)="navigateToAd($event)"
					></app-listing-card>
					<div
						class="col-12 text-center"
						*ngIf="!listings || (listings.length === 0 && !(showWelcome$ | async))"
					>
						No listings found with the given criteria. Please try again.
					</div>
				</div>
				<ng-container *ngTemplateOutlet="paginationTemplate"></ng-container>
			</div>
		</ng-container>
	</ng-template>
	<ng-template #loadingTemplate>
		<div class="container-lg">
			<div class="col-12 text-center">Loading listings...</div>
		</div>
	</ng-template>
	<ng-template #paginationTemplate>
		<div class="row">
			<app-pagination
				class="col-12 col-lg-6 offset-lg-3 align-self-center"
				[currentPage]="currentPage$ | async"
				[pageLength]="pageSizeControl?.value || 10"
				[itemCount]="resultCount$ | async"
				(pageTo)="pageTo($event)"
			></app-pagination>
			<ng-container *ngIf="currentRange$ | async as currentRange">
				<div
					*ngIf="currentRange.total > 0"
					class="col-12 col-lg-3 text-end text-dark small align-self-center"
				>
					Viewing&nbsp;{{ currentRange.start }}-{{
						currentRange.end > currentRange.total ? currentRange.total : currentRange.end
					}}
					of&nbsp;{{
						currentRange.total + (currentRange.total >= maxSearchResults ? "+" : "")
					}}&nbsp;listings
				</div>
			</ng-container>
		</div>
	</ng-template>
</div>

<ng-template #deleteModal let-modal>
	<div class="modal-body">
		<p>Are you sure you wish to delete listing #{{ currentListingSummary?.listingID }}?</p>
	</div>
	<div class="modal-footer">
		<button class="btn" (click)="modal.close()">Cancel</button>
		<button
			class="btn btn-outline-danger"
			(click)="modal.close(); deleteListing(currentListingSummary)"
		>
			Delete
		</button>
	</div>
</ng-template>
<ng-template #recoverModal let-modal>
	<div class="modal-body">
		<p>Are you sure you wish to recover listing #{{ currentListingSummary?.listingID }}?</p>
	</div>
	<div class="modal-footer">
		<button class="btn" (click)="modal.close()">Cancel</button>
		<button
			class="btn btn-outline-primary"
			(click)="modal.close(); recoverListing(currentListingSummary)"
		>
			Recover
		</button>
	</div>
</ng-template>
<ng-template #copyModal let-modal>
	<div class="modal-body">
		<p>Are you sure you wish to copy listing #{{ currentListingSummary?.listingID }}?</p>
	</div>
	<div class="modal-footer">
		<button class="btn" (click)="modal.close()">Cancel</button>
		<button
			class="btn btn-outline-primary"
			(click)="modal.close(); copyListing(currentListingSummary, copyingModal)"
		>
			Copy
		</button>
	</div>
</ng-template>
<ng-template #cloneModal let-modal>
	<div class="modal-body">
		<p>Are you sure you wish to clone listing #{{ currentListingSummary?.listingID }}?</p>
	</div>
	<div class="modal-footer">
		<button class="btn" (click)="modal.close()">Cancel</button>
		<button
			class="btn btn-outline-primary"
			(click)="modal.close(); cloneListing(currentListingSummary, cloningModal)"
		>
			Clone
		</button>
	</div>
</ng-template>
<ng-template #copyingModal let-modal>
	<div class="modal-body d-flex flex-column justify-content-center">
		<p>Copying #{{ currentListingSummary?.listingID }}...</p>
		<div class="spinner-border text-secondary align-self-center" role="status"></div>
	</div>
</ng-template>
<ng-template #cloningModal let-modal>
	<div class="modal-body d-flex flex-column justify-content-center">
		<p>Cloning #{{ currentListingSummary?.listingID }}...</p>
		<div class="spinner-border text-secondary align-self-center" role="status"></div>
	</div>
</ng-template>
